import { create } from "zustand";

interface CampaignsModalState {
  open: boolean;
  /** Initially-selected campaign id for the right pane (defaults to active campaign). */
  initialSelectedCampaignId: string | null;
  openModal: (initialSelectedCampaignId?: string | null) => void;
  closeModal: () => void;
}

export const useCampaignsModalStore = create<CampaignsModalState>((set) => ({
  open: false,
  initialSelectedCampaignId: null,
  openModal: (initialSelectedCampaignId = null) =>
    set({ open: true, initialSelectedCampaignId }),
  closeModal: () => set({ open: false, initialSelectedCampaignId: null }),
}));
